import { del, get, patch, post, put } from './http-methods';
import axiosInstance from "./axiosInstance";

export const API = {
  sendEmailOtp: (payload: any) => post('/api/v1/send-email-otp/', payload),
  confirmEmailOtp: (payload: any) => post('/api/v1/confirm-email-otp/', payload),
  getRegions: () => get('/api/v1/region/'),
  register: (payload: any) => post('/api/v1/signup/', payload),
  login: (payload: any) => post('/api/v1/login/', payload),
  logout: () => post('/api/v1/logout/'),
  resetSendEmailOtp: (payload: any) => post('/api/v1/reset-password/send-email-otp/', payload),
  resetConfirmEmailOtp: (payload: any) =>
    post('/api/v1/reset-password/confirm-email-otp/', payload),
  resetUserPassword: (payload: any) => post('/api/v1/reset-password/', payload),
  getSubKpiList: () => get('/kpi/api/v1/sub-kpi/'),
  addKpi: (payload: any) => post('/kpi/api/v1/kpi/', payload),
  editKpi: (id: any, payload: any) => patch(`/kpi/api/v1/kpi/${id}/`, payload),
  getKpi: (id: any) => get(`/kpi/api/v1/kpi/${id}/`),
  getKpiPriorities: () => get(`/kpi/api/v1/kpi-priority/`),
  getKpiList: (payload: any) =>
    get(
      payload?.sort_by && payload?.category
        ? `/kpi/api/v1/kpi/?category=${payload?.category}&sort_by=${payload?.sort_by}`
        : `/kpi/api/v1/kpi/${
            payload?.category
              ? '?category=' + payload?.category
              : payload?.sort_by
              ? '?sort_by=' + payload?.sort_by
              : ''
          }`,
    ),
  delKpi: (id: any) => del(`/kpi/api/v1/kpi/${id}/`),
  getCompanyList: (company_ids?: number[]) =>
    get(
      company_ids?.length
        ? `/api/v1/company/?company_ids=${company_ids.join(',')}`
        : '/api/v1/company/',
    ),
  fetchReportData: (payload: any) => post('/kpi/api/v1/report-data/', payload),
  exportReportData: (payload: any, config?: any) => post('/kpi/api/v1/export-report-data/', payload, config),
  addOrEditReportData: (payload: any) => post('/kpi/api/v1/add-report-data/', payload),
  getCustomerList: (payload: any) =>
    get(
      payload?.company_ids?.length > 0
        ? `/api/v1/customer/?company_ids=${payload?.company_ids?.join(',')}`
        : payload?.customer_ids?.length > 0
        ? `/api/v1/customer/?customer_ids=${payload?.customer_ids?.join(',')}`
        : `/api/v1/customer/`,
    ),
  fetchChartData: (payload: any) => post('/kpi/api/v1/chart/', payload),
  getScorecard: (payload: any) =>
    get(
      `/kpi/api/v1/scorecard/?start_date=${payload?.start_date}&mid_date=${payload?.middle_date}&end_date=${payload?.end_date}&distributors=${payload?.distributors}&filter=${payload?.category}`,
    ),
  exportScorecard: (payload: any, config?: any) =>
    post('/kpi/api/v1/scorecard/export/', payload, config),
  getUsers: (config:any) => get('/api/v1/user/',config),
  checkImpersonate: () => get(`/users/impersonation/check-impersonate/`),
  stopImpersonate: () => post(`/users/impersonation/stop-impersonate/`),
  editUser: (id: any, payload: any) => put(`/api/v1/user/${id}/`, payload),
  changePassword: (payload: any) => post(`/api/v1/change-password/`, payload),
  delUser: (id: any) => del(`/api/v1/user/${id}/`),
  getFeedbackList: (payload: any) =>
    get(
      `/feedback/api/v1/feedback/${payload?.thread_id ? '?thread_id=' + payload?.thread_id : ''}`,
    ),
  postFeedback: (payload: any) => post('/feedback/api/v1/feedback/', payload),
  updateFeedback: (id: any, payload: any) => patch(`/feedback/api/v1/feedback/${id}/`, payload),
  readThreads: (id: any, payload: any) =>
    patch(`/feedback/api/v1/feedback/${id}/read-threads/`, payload),
  delFeedback: (id: any) => del(`/feedback/api/v1/feedback/${id}/`),
  getFeedbackCount: () => get('/feedback/api/v1/feedback/unread-count/'),
  replyFeedback: (payload: any) => post('/feedback/api/v1/feedback-reply/', payload),
  uploadChartImage: (payload: any) => post('/kpi/api/v1/upload-chart-image/', payload),
  getContactUs: () => get('/feedback/api/v1/contact-us/'),
  postDashboard: (payload: any) => post('/kpi/api/v1/dashboard/', payload),
  getBookmark: (payload: any) => get(`/api/v1/bookmark/${payload?.module ? "?module=" + payload?.module : ""}`),
  addBookmark: (payload: any) => post('/api/v1/bookmark/', payload),
  updateBookmark: (id: any, payload: any) => patch(`/api/v1/bookmark/${id}/`, payload),
  deleteBookmark: (id: any) => del(`/api/v1/bookmark/${id}/`),
  getDashboardPreferences: () => get('/kpi/api/v1/dashboard-preferences/'),
  createDashboardPreferences: (payload: any) => post('/kpi/api/v1/dashboard-preferences/', payload),
  updateDashboardPreferences: (id: number, payload: any) => put(`/kpi/api/v1/dashboard-preferences/${id}/`, payload),
};

export const categories = [
  { id: 1, label: 'SAFETY' },
  { id: 2, label: 'LEGAL' },
  { id: 3, label: 'QUALITY' },
  { id: 4, label: 'DELIVERY' },
  { id: 5, label: 'COST' },
  { id: 6, label: 'REBUILDS' },
];

export const priorities = [
  { id: 1, label: 'GLOBAL' },
  { id: 2, label: 'REGIONAL' },
  { id: 3, label: 'LOCAL' },
];

// Added for the new API
export const listFinancialYears = () =>
  axiosInstance.get("/kpi/api/v1/financial-years/");

// ─── Dashboard Preferences ────────────────────────────────
export const getDashboardPreferences = () =>
  get('/kpi/api/v1/dashboard-preferences/');

export const createDashboardPreferences = (payload: any) =>
  post('/kpi/api/v1/dashboard-preferences/', payload);

export const updateDashboardPreferences = (id: number, payload: any) =>
  patch(`/kpi/api/v1/dashboard-preferences/${id}/`, payload);

export const statuses = [
  { id: 1, label: 'Draft' },
  { id: 2, label: 'Approved' },
];

export const permissions = [
  { id: 1, label: 'OEM_EDITABLE' },
  { id: 2, label: 'COMPANY_EDITABLE' },
];

export const financialYear = [
  { id: 1, label: '2021-22' },
  { id: 2, label: '2022-23' },
  { id: 3, label: '2023-24' },
  { id: 4, label: '2024-25' },
];

export const subKpiType = [
  { id: 1, label: 'Overall' },
  { id: 2, label: 'Company Specific' },
  { id: 3, label: 'Customer Specific' },
];

export const usertype = [
  { id: 1, label: 'OEM_ADMIN' },
  { id: 2, label: 'OEM_STAFF' },
  { id: 3, label: 'COMPANY_ADMIN' },
  { id: 4, label: 'COMPANY_STAFF' },
];

export const DATA_TYPE_PERCENTAGE = 1;
export const DATA_TYPE_RECORDS = 2;
export const DATA_TYPE_DAYS = 3;
export const DATA_TYPE_DECIMAL = 4;

export const subKPIDataType = [
  { id: DATA_TYPE_PERCENTAGE, label: 'Percentage', symbol: '%' },
  { id: DATA_TYPE_RECORDS, label: 'Records', symbol: '#' },
  { id: DATA_TYPE_DAYS, label: 'Days', symbol: 'Days' },
  { id: DATA_TYPE_DECIMAL, label: 'Decimal', symbol: 'Decimal' },
];

export const BOOKMARK_DASHBOARD = 1;
export const BOOKMARK_VIEW_REPORTS = 2;
export const BOOKMARK_GENERATE_SCORECARD = 3;
export const BOOKMARK_GENERATE_CHART = 4;
export const BOOKMARK_MODULE = [
  { id: BOOKMARK_DASHBOARD, label: 'Dashboard' },
  { id: BOOKMARK_VIEW_REPORTS, label: 'View Reports' },
  { id: BOOKMARK_GENERATE_SCORECARD, label: 'Generate Scorecard' },
  { id: BOOKMARK_GENERATE_CHART, label: 'Generate Chart' },
];

export const FILL_CHART = ['radar', 'doughnut', 'pie', 'polarArea'];
